import axios from '@/service/request';
import type { R, ChannelTypeEnum, BuyerOperationTypeEnum } from './types';
import type { MiniLoginResponse } from './buyerWechatLogin';

/**
 * 验证码登录/注册请求参数
 */
export interface MiniCaptchaLoginRequest {
  /** 手机国内号码或邮箱 */
  account?: string;
  /** 手机国际区号（如 +86），邮箱登录不传 */
  countryRegionCode?: string;
  /** 验证码 */
  captcha?: string;
  /** 登录/注册渠道 */
  channel?: ChannelTypeEnum;
  /** 操作类型 */
  operationType?: BuyerOperationTypeEnum;
}

/**
 * 验证码登录/注册
 */
export const apiBuyerLoginCaptcha = (data: MiniCaptchaLoginRequest): Promise<R<MiniLoginResponse>> => {
  return axios.post('/buyer/login/captcha', data);
};

